import { useState, useEffect } from 'react';

/**
 * useScrollSpy — tracks which section is currently visible in the viewport
 * and returns its id as the active section.
 *
 * @param {string[]} sectionIds - ordered list of section element ids
 * @param {number}   offset     - pixels from top to trigger a section switch
 * @returns {string} activeId
 */
export function useScrollSpy(sectionIds, offset = 80) {
  const [activeId, setActiveId] = useState(sectionIds[0]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + offset + 1;

      // Walk through sections from bottom to top and find the first one
      // whose top is at or above the current scroll position
      let current = sectionIds[0];
      for (const id of sectionIds) {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= scrollPos) {
          current = id;
        }
      }
      setActiveId(current);
    };

    handleScroll(); // run once on mount
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sectionIds, offset]);

  return activeId;
}
